<script setup>
import {ref} from "vue";
import {animate} from "@straylightagency/animate";
import {easeOutQuad} from "@straylightagency/animate/easing"
import smooth from "../lib/smooth";
import {__} from "../lib/localization/index.js";

const el = ref();

async function goTo(event) {
    document.body.classList.add('overflow-hidden');

    await animate( {
        from: window.scrollY,
        to: 0,
        duration: 1500,
        easing: easeOutQuad,
        update: value => {
            window.scrollTo( 0, value );
            smooth.update( 0, value, event );
        },
    } );

    document.body.classList.remove('overflow-hidden');
}

</script>

<template>
    <button ref="el" @click.prevent="goTo" class="scroll-top" :title="__('labels.back-to-top')">
        <slot></slot>
    </button>
</template>